import AxiosInstance from "./AxiosInstance";

// Get All Destinations
export const getAllPrefferPartner = async () => {
  try {
    const { data } = await AxiosInstance.get("/preffer_partner");
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Create Destination
export const createPrefferPartner = async (preffer_partner) => {
  try {
    const { data } = await AxiosInstance.post(
      "/preffer_partner",
      preffer_partner
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Update Destination
export const updatePrefferPartner = async (preffer_partner) => {
  try {
    const { data } = await AxiosInstance.put(
      "/preffer_partner",
      preffer_partner
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Delete Destination
export const deletePrefferPartner = async (preffer_partner) => {
  try {
    const { data } = await AxiosInstance.delete(
      `/preffer_partner/${preffer_partner._id}`
    );
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};
